__webpack_require__.p = "https://gentle-grass-02d3f240f.1.azurestaticapps.net/";